import React from 'react';
import PropTypes from 'prop-types';

class SMMessageTimelineView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      message: this.props.message,
    };
  }
  
  render() {
    return (
      <h3 className="dashboard-message__status">{this.state.message.content}</h3>
    );
  }
}

SMMessageTimelineView.propTypes = {
  message: PropTypes.object.isRequired,
};
export default SMMessageTimelineView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageTimelineView.jsx